import {useEffect, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'

import {BASE_CLASS, NO_OP} from '../../../config.js'
import {DESIGNS} from './config.js'

const FilterBasicLegacySingleSelectionItem = ({
  design = DESIGNS.SPACED,
  extendedInfo,
  icon: Icon,
  id,
  isDisabled = false,
  isHighlighted = false,
  isSelected: isSelectedFromProps,
  label,
  onChange = NO_OP
}) => {
  const [isSelected, setIsSelected] = useState(isSelectedFromProps)

  const hasIcon = Boolean(Icon)
  const hasExtendedInfo = Boolean(extendedInfo)

  const filterBasicLegacySingleSelectionItemClassName = cx(
    `${BASE_CLASS}-singleSelectionItem`,
    `${BASE_CLASS}-singleSelectionItem--${design}`,
    {[`${BASE_CLASS}-singleSelectionItem--disabled`]: isDisabled}
  )

  const filterBasicLegacySingleSelectionLabelClassName = cx(`${BASE_CLASS}-singleSelectionItemLabel`, {
    [`${BASE_CLASS}-singleSelectionItemLabel--bold`]: isSelected || isHighlighted
  })

  const filterBasicLegacySingleSelectionLabelWrapperClassName = cx(`${BASE_CLASS}-singleSelectionItemLabelWrapper`, {
    [`${BASE_CLASS}-singleSelectionItemLabelWrapper--spaced`]: hasIcon && !hasExtendedInfo
  })

  const handleClick = () => {
    if (isDisabled) return

    setIsSelected(!isSelected)

    setTimeout(() => {
      onChange({id, label})
    }, 0)
  }

  useEffect(() => {
    isSelectedFromProps !== isSelected && setIsSelected(isSelectedFromProps)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelectedFromProps])

  return (
    <div onClick={handleClick}>
      <div className={filterBasicLegacySingleSelectionItemClassName}>
        {hasIcon && (
          <div className={`${BASE_CLASS}-singleSelectionItemIconWrapper`}>
            <Icon size={atomIconSizes.medium} />
          </div>
        )}
        <div className={filterBasicLegacySingleSelectionLabelWrapperClassName}>
          <p className={filterBasicLegacySingleSelectionLabelClassName}>{label}</p>
          {hasExtendedInfo && <p className={`${BASE_CLASS}-singleSelectionItemExtendedInfo`}>{extendedInfo}</p>}
        </div>
      </div>
    </div>
  )
}

FilterBasicLegacySingleSelectionItem.displayName = 'FilterBasicLegacySingleSelectionItem'
FilterBasicLegacySingleSelectionItem.propTypes = {
  design: PropTypes.oneOf(Object.values(DESIGNS)),
  extendedInfo: PropTypes.string,
  icon: PropTypes.func,
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export {DESIGNS as filterBasicLegacySingleSelectionItemDesigns}

export default FilterBasicLegacySingleSelectionItem
